module.exports = __webpack_public_path__ + "img/sprite.554207ae.svg";